import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  quote: 'Me ayudó a ordenar muchísimo mi trabajo.',
  author: 'Lic. M.G.',
  role: 'Fonoaudióloga'
}, {
  quote: 'Ahora tengo recursos a mano y ahorro mucho tiempo.',
  author: 'Fga. C.R.',
  role: 'Fonoaudióloga'
}, {
  quote: 'Se nota más profesional mi forma de presentar el material.',
  author: 'Lic. A.P.',
  role: 'Especialista en Lenguaje'
}, {
  quote: 'La opción completa fue la mejor decisión.',
  author: 'Fga. S.L.',
  role: 'Fonoaudióloga Clínica'
}];
export function Testimonials() {
  return <section className="py-8 bg-transparent relative" data-id="element-221">
      <div className="container mx-auto px-6 max-w-6xl relative z-10" data-id="element-222">
        <div className="text-center mb-16" data-id="element-223">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-224">
            Lo que dicen los profesionales
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-225">
            Una herramienta pensada para quienes quieren trabajar mejor, ahorrar
            tiempo y elevar su práctica profesional.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-226">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="glass-card p-8 rounded-2xl relative" data-id="element-227">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-white/5" data-id="element-228" />
              <div className="flex gap-1 mb-6" data-id="element-229">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-orange-500 text-orange-500" data-id="element-230" />)}
              </div>
              <p className="text-gray-300 font-medium mb-8 leading-relaxed" data-id="element-231">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-232">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-500 to-yellow-500 flex items-center justify-center text-white font-bold text-sm shadow-lg" data-id="element-233">
                  {t.author.split(' ')[1]?.[0] || t.author[0]}
                </div>
                <div data-id="element-234">
                  <div className="text-white font-bold text-sm" data-id="element-235">{t.author}</div>
                  <div className="text-orange-400 text-xs" data-id="element-236">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}